import { UserId } from "@researchwiseai/identities"

interface Item {
    productId: string
    quantity: number
}

interface Props {
    items: Item[]
    userId?: UserId | null | undefined
}

export async function postCalculations({ items, userId }: Props) {
    const url = `${process.env.NEXT_PUBLIC_CREDITS_API_URL}/v1/calculations`

    const r = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            items,
            userId: userId?.toUrl() ?? null,
        }),
    })

    return (await r.json()) as { items: Item & { total: number }[] }
}
